import {
  Autocomplete,
  createFilterOptions,
  TextField,
  useMediaQuery,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTheme } from "@emotion/react";
import { AuthContext } from "../../../../context/AuthContext";

const filter = createFilterOptions();

const SelectEventOrder = ({
  value,
  label = "Select Industry Job",
  onUpdate,
  disabled,
  onBlur,
  error,
  helperText,
  ...props
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { authToken, ezorder } = useContext(AuthContext);
  const [jobs, setJobs] = useState();
  const [loading, setLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  const getAvailableJobs = async (controller) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(`/shop/jobs/all`, data);

      if (response.status == 200) {
        setJobs(response.data.jobs);
      } else {
        setJobs([]);
      }
    } catch (error) {
      console.log(error);
      setJobs([]);
    } finally {
      setLoading(false);
      setHasLoaded(true);
    }
  };

  useEffect(() => {
    getAvailableJobs();
  }, []);

  if (hasLoaded && jobs)
    return (
      <Autocomplete
        value={value}
        disabled={disabled}
        handleHomeEndKeys
        onChange={(event, newValue) => {
          // console.log("Value is object or null", newValue);
          // console.log("SET VALUE", newValue);
          if (onUpdate) onUpdate(newValue ?? null);
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          return filtered;
        }}
        options={jobs}
        getOptionLabel={(option) => {
          // for example value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return `Job #${option.id} - ${option.project.name}`;
        }}
        selectOnFocus
        clearOnBlur
        isOptionEqualToValue={(option, value) => {
          //  The "selected" prop on renderOption depends on this
          if (!value) return false;
          return value.id == option.id;
        }}
        freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            size={props.size ? props.size : "small"}
            label={label}
            sx={{
              width: "100%",
            }}
            variant="outlined" // filled, outlined, standard
            onBlur={onBlur}
            error={error}
            helperText={helperText}
          />
        )}
      />
    );
};

export default SelectEventOrder;
